<template>
	<div class="w-table-layout w-table-page">
		<div class="w-table-content"
			 ref="tableContent">
			<el-table :data="tableData"
					  highlight-current-row
					  v-loading="loading"
					  stripe
					  :height="tableH">
				<el-table-column type="index"
								 label="序号"
								 align="center"
								 min-width="50">
				</el-table-column>

				<el-table-column prop="projectName"
								 label="项目名称"
								 show-overflow-tooltip
								 align="center"
								 min-width="150">
				</el-table-column>
				<el-table-column prop="phaseName"
								 label="造价阶段"
								 align="center"
								 min-width="150">
				</el-table-column>
				<el-table-column prop="fileName"
								 label="造价文件名称"
								 show-overflow-tooltip
								 min-width="130">
					<template slot-scope="scope">
						<a class="rowName">{{ scope.row.fileName }}</a>
					</template>
				</el-table-column>
				<el-table-column prop="upLoadUserName"
								 label="上传人"
								 align="center"
								 min-width="120">
				</el-table-column>
				<el-table-column prop="uploadDate"
								 label="上传日期"
								 align="center"
								 show-overflow-tooltip
								 min-width="120">
				</el-table-column>
				<el-table-column prop="pricebasisName"
								 show-overflow-tooltip
								 label="计价依据"
								 align="center"
								 min-width="300">
				</el-table-column>
				<el-table-column prop="fileType"
								 label="文件类型"
								 align="center"
								 min-width="120">
					<template slot-scope="scope">
						<div>{{ scope.row.fileType === 1 ? 'EXCEL' : 'XML' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="dataState"
								 label="数据处理"
								 align="center"
								 min-width="120">
					<template slot-scope="scope">
						<div>{{ scope.row.dataState === 1 ? '已处理' : '未处理' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="unitProjectQuantity"
								 label="单位工程数量"
								 header-align="center"
								 align="center"
								 width="130">
				</el-table-column>
				<el-table-column prop="acceptDate"
								 label="处理日期"
								 align="center"
								 show-overflow-tooltip
								 width="120">
				</el-table-column>
				<el-table-column prop="accuserName"
								 label="处理人"
								 align="center"
								 width="120">
				</el-table-column>
				<el-table-column label="操作"
								 min-width="100">
					<template slot-scope="scope">
						<el-button @click="deleteClick(scope.row)"
								   type="text"
								   v-show="phaseArr.includes(scope.row.phase)"
								   size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="w-table-footer">
			<el-pagination @size-change="SizeChange"
						   @current-change="CurrentChange"
						   :current-page="currentPage"
						   :page-sizes="pageList"
						   :page-size="pageSize"
						   layout="total, sizes, prev, pager, next, jumper"
						   :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	selectCostPage,
	deleteCostDetail
} from '@/api/modules/project_costfiles'
import { mapState } from 'vuex'
export default {
	name: 'cost-files-table',
	props: {
		searchForm: {
			type: Object,
			defatult: () => {
				return {}
			}
		},
		projectId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			loading: false,
			tableData: [],
			tableH: 0
		}
	},
	created() {
		// 初始获得表格数据
		this.$nextTick(() => {
			this.getTableData()

			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 初始获得数据
		getTableData() {
			// 设置参数
			this.tableData = []
			let params = Object.assign({}, this.searchForm)
			params.current = this.currentPage
			params.size = this.pageSize
			params.aid = this.projectId
			this.loading = true
			selectCostPage(params)
				.then(res => {
					this.loading = false
					if (res.code === 0) {
						this.tableData.push(...res.data.records)
						this.currentPage = parseInt(res.data.current)
						this.total = parseInt(res.data.total)
						this.pageSize = parseInt(res.data.size)
					} else {
						this.$message.error(res.msg)
					}
				})
				.catch(err => {
					this.loading = false
				})
		},
		deleteClick(row) {
			this.$confirm('确认要删除当前数据吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					deleteCostDetail({ id: row.id }).then(res => {
						if (res.code === 0) {
							this.$message.success('删除成功！')
							this.getTableData()
						} else {
							this.$message.error('删除失败！')
						}
					})
				})
				.catch(() => {})
		},
		// 切换显示条数
		SizeChange(val) {
			this.pageSize = val
			this.getTableData()
		},
		// 切换当前页码
		CurrentChange(current) {
			this.currentPage = current
			this.getTableData()
		}
	},
	computed: {
		...mapState('app', {
			clientSize: state => state.clientSize
		}),
		phaseArr() {
			return ['1007002', '1007003', '1007004', '1007005', '1007006']
		}
	},
	watch: {
		clientSize() {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		}
	}
};
</script>
<style lang="less" scoped>
@import './cost-fils-updat.less';
</style>